// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"68373b2e","115":"95f2cbf1","214":"b7ebf5fb","434":"93763771","641":"94bb98ce"}[chunkId] + ".chunk.js";
};